import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ClassiService {
  static getAllClassi = () => {
    let url = `${REACT_APP_REST_ENDPOINT}/classi`;
    return ApiService.getRudeRequest(url);
  };

  static getClassiByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/find`;
      ApiService.postRudeRequest(resolve, reject, url, params)
  });
  };

  static updateStateClasse = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/update-stato`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  }

  static getClassiByParamsNoAuth = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/find-public`;
      ApiService.postNoAuthRequest(resolve, reject, url, params)
  });
  };

  static getMaterialiClasse = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/get-materiali-classe`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static getMaterialiClasseByUserId = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/get-materiali-classe-by-user-id`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static createClasse = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteClasse = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateClasse = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/classi/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}